import React, { useEffect } from 'react';
import styles from './MediaInfo.css';
import { parseDescription } from '../../../media/description';
import { LinkText, Header3 } from '../../common/typography';
import { TimestampButton } from '../../media/TimestampButton';
import { Time } from 'components/media/Time';
import { t } from 'locale';
function MediaInfo(props) {
    const { media, onClose } = props;
    useEffect(() => {
        if (!media && onClose) {
            onClose();
        }
    }, [media, onClose]);
    if (!media)
        return null;
    const fragments = media && media.description ? parseDescription(media.description) : [];
    const description = fragments.map((fragment, idx) => {
        switch (fragment.type) {
            case "text" /* TEXT */:
                return fragment.content;
            case "timestamp" /* TIMESTAMP */:
                return React.createElement(TimestampButton, { key: idx, timestamp: fragment.content });
            case "link" /* LINK */:
                return (React.createElement(LinkText, { key: idx, href: fragment.content, target: "_blank", rel: "nofollow noopener" }, fragment.content));
        }
    });
    const { title, requestUrl: href, duration } = media;
    return (React.createElement("section", { className: styles.container },
        React.createElement(Header3, null, t('title')),
        React.createElement("p", null, title),
        React.createElement(Header3, null, t('link')),
        React.createElement("p", null,
            React.createElement(LinkText, { href: href, target: "_blank" }, href)),
        duration ? (React.createElement(React.Fragment, null,
            React.createElement(Header3, null, t('duration')),
            React.createElement("p", null,
                React.createElement(Time, { time: duration })))) : null,
        media.description ? (React.createElement(React.Fragment, null,
            React.createElement(Header3, null, t('description')),
            React.createElement("div", { className: styles.description }, description))) : null));
}
export default MediaInfo;
